export default __webpack_public_path__ + "static/media/reset-icon.80c9eabd.svg";